module.exports = __webpack_public_path__ + "static/media/gallery4.bd94af96.jpg";